import _PhoneNumber from 'awesome-phonenumber';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupPhoneNumber } from 'awesome-phonenumber';

export const PhoneNumber = _rollupPhoneNumber || _PhoneNumber;
